import { Component, OnInit } from "@angular/core";
import { SpinnerService, SpinnerState } from "./spinner.service";

@Component({
  selector: "gca-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["spinner.component.scss"],
})
export class SpinnerComponent implements OnInit {
  disableFullScreen = true;
  text: string;
  visible = false;

  constructor(private spinnerService: SpinnerService) {
    this.spinnerService.spinnerState.subscribe((spinnerState: SpinnerState) => {
      this.visible = !!spinnerState;

      if (!window["sso"]) {
        this.visible = true;
        this.text = "Please wait. Checking login status...";
      }
      this.text = spinnerState.text;
    });
  }
  ngOnInit(): void {
    if (!window["sso"]) {
      this.visible = true;
      this.text = "Please wait. Checking login status...";
    }
  }
}
